"use client";
import Script from "next/script";

const GA_MEASUREMENT_ID = "G-NZY5QYE1D1";

function GoogleAnalytics() {
	return (
		<>
			<Script
				id="xhl-tracking"
				strategy="afterInteractive"
				dangerouslySetInnerHTML={{
					__html: `
						if (!window._XHL) {
							(function (x, h, l, j, s, z) {
								x[j] = x[j] || function () {
									(x[j].a = x[j].a || []).push(arguments);
								};
								s = h.createElement(l);
								z = h.getElementsByTagName(l)[0];
								s.async = true;
								s.charset = 'UTF-8';
								s.src = 'https://libtx.leadscloud.com/xhltrackingwithchat.js';
								z.parentNode.insertBefore(s, z);
							})(window, document, 'script', '_XHL');
							window._XHL('entID', 200891);
						}
					`,
				}}
			/>
			<Script
				strategy="afterInteractive"
				src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
			/>
			<Script
				id="google-analytics"
				strategy="afterInteractive"
				dangerouslySetInnerHTML={{
					__html: `
						window.dataLayer = window.dataLayer || [];
						function gtag(){dataLayer.push(arguments);}
						gtag('js', new Date());
						gtag('config', '${GA_MEASUREMENT_ID}', {
							anonymize_ip: true,
							cookie_flags: 'SameSite=None;Secure'
						});
					`,
				}}
			/>
		</>
	);
}

export default GoogleAnalytics;
